import {Enum} from '@/app/shared/enum/enum';

export namespace AccountCheckConfig {
  export const IS_PC: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.UNKNOWN,

    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_NAVER
  ];

  export const IS_MOBILE: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_TV_OLLEH,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_TV_U_PLUS,

    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_OPEN_API,

    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_CTN_LG,
  ];

  export const IS_APP: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_HOME_BOY,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_HOME_TABLET,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_HOME_PHONE,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_CTN_LG,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_NAVER,
  ];

  export const IS_DEFAULT: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_HOME_TABLET,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_HOME_PHONE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_TV_OLLEH,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_TV_U_PLUS,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_UNKNOWN,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_UNKNOWN,
  ];

  export const IS_SNS: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_TABLET_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.PC_WEB_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_NAVER,
  ];

  export const IS_APPLE: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_APPLE,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_CARPALY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_APPLE,
  ];

  export const IS_CTN: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_HOME_BOY,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_AUTO_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_AUTOMOTIVE_CTN_LG,
  ];

  export const IS_GIGA: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_KAKAOTALK,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_LTE2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_TABLE_TV2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_BUDDY_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SOUND_BAR_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_LTE2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_TABLE_TV2_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_BUDDY_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SOUND_BAR_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX2_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX3_ATV_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX2_ATV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX3_ATV_CTN_KT,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_TWITTER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_GBOX4_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_GBOX4_NAVER,

    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_SKYLIFE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_GIGA_HCN_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_SKYLIFE_TV_CTN_KT,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_UNKNOWN,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_FACEBOOK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_APPLE,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_KAKAOTALK,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_NAVER,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_CTN_LG,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_GIGA_HCN_TV_CTN_KT,
  ];

  export const IS_HOME_BOY: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_CTN_HOME_BOY
  ];

  export const IS_OPEN_API: Enum.ACCOUNT.CHECK.JOIN_CODE[] = [
    Enum.ACCOUNT.CHECK.JOIN_CODE.MOBILE_WEB_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_IPHONE_OPEN_API,
    Enum.ACCOUNT.CHECK.JOIN_CODE.APP_ANDROID_OPEN_API
  ];
}
